import { Injectable } from '@angular/core';
import * as UAParser from "ua-parser-js";
const DEVICE_ID_KEY = 'CHAPPS_BROWSER_TRUST_KEY';

@Injectable()
export class DeviceService {

  private readonly parser = new UAParser();

  constructor() { }

  get deviceId() {
    let deviceId = localStorage.getItem(DEVICE_ID_KEY);
    if (!deviceId) {
      deviceId = this.generateDeviceId();
      localStorage.setItem(DEVICE_ID_KEY, deviceId);
    }
    return deviceId;
  }

  get os() {
    const os = this.parser.getOS();
    return `${os.name} ${os.version}`;
  }

  get browser() {
    const info = this.parser.getBrowser();
    return `${info.name} (${info.version})`;
  }

  private generateDeviceId() {
    return crypto.randomUUID();
  }



}
